/* ---------------------------------------- [START] isInViewport */
function isInViewport(el) {
	var rect = el.getBoundingClientRect();

	var isVisible = el.offsetHeight !== 0;

	return (
		isVisible &&
		rect.bottom >= 0 &&
		rect.right >= 0 &&
		rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.left <= (window.innerWidth || document.documentElement.clientWidth)
	);
}
/* ---------------------------------------- [END] isInViewport */

/* ---------------------------------------- [START] 簡單的節流函數 */
// https://www.cnblogs.com/coco1s/p/5499469.html
function throttle(func, wait, mustRun) {
	var timeout;
	var startTime = new Date();

	return function () {
		var context = this;
		var args = arguments;
		var curTime = new Date();

		if (timeout !== undefined) {
			if (window.requestTimeout !== undefined) clearRequestTimeout(timeout);
			else clearTimeout(timeout);
		}
		// 如果達到了規定的觸發時間間隔，觸發 handler
		if (curTime - startTime >= mustRun) {
			func.apply(context, args);
			startTime = curTime;
			// 沒達到觸發間隔，重新設定定時器
		} else {
			if (window.requestTimeout !== undefined) timeout = requestTimeout(func, wait);
			else timeout = setTimeout(func, wait);
		}
	};
}
/* ---------------------------------------- [END] 簡單的節流函數 */

(function (window, document) {
	/* ----------------------------------- [START] Windows Setting */
	const html = document.documentElement;
	// const body = document.body || document.querySelector('body');
	let ww = window.innerWidth;
	let wh = window.innerHeight;
	let ws = 0;
	function getScrollTop(target = window) {
		return (target.pageYOffset || html.scrollTop) - (html.clientTop || 0);
	}
	function getWinSet() {
		ww = window.innerWidth;
		wh = window.innerHeight;
		ws = getScrollTop();
	}

	// on(window, 'load', getWinSet);
	// on(window, 'resize', getWinSet);
	/* ----------------------------------- [END] Windows Setting */

	var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

	/* ---------------------------------------- [START] 整頁 Scroll 監測 (Before) */
	var pageScrollCheckList = []; // 紀錄物件

	var pageScrollAdd = function (selector, buildFunction) {
		var el = document.querySelector(selector);
		if (el === null) {
			return false;
		}
		pageScrollCheckList.push({
			build: false,
			el: el,
			fun: buildFunction,
		});
	};

	var pageScrollClean = function () {
		pageScrollCheckList = Array.prototype.filter.call(pageScrollCheckList, function (item) {
			return item.build === false;
		});
	};
	/* ---------------------------------------- [END] 整頁 Scroll 監測 (Before) */

	/* ---------------------------------------- [START] Product Recommend | 推薦產品  */
	const pdRecommendCarousel = '#pd-recommend-carousel'; // .swiper-container id

	function pdRecommendBuild() {
		const swiperTarget = pdRecommendCarousel;
		const swiperEl = document.querySelector(swiperTarget).parentElement;
		const swiperPageEl = swiperEl.querySelector('.swiper-pagination');
		const swiperNextEl = swiperEl.querySelector('.swiper-button-next');
		const swiperPrevEl = swiperEl.querySelector('.swiper-button-prev');

		const swiper = new Swiper(swiperTarget, {
			spaceBetween: 20,
			slidesPerView: 2,
			slidesPerGroup: 2,
			// loop: true, // Loop 會有 Checkbox 重複的問題，即使刪掉也沒用
			lazy: true,
			preloadImages: false,
			// [START] Global Pagination + Button (Prev, Next)
			pagination: {
				el: swiperPageEl,
				type: 'fraction',
			},
			navigation: {
				nextEl: swiperNextEl,
				prevEl: swiperPrevEl,
			},
			// [END] Global Pagination + Button (Prev, Next)
			breakpoints: {
				1024: {
					slidesPerView: 3,
					slidesPerGroup: 3,
				},
				1200: {
					slidesPerView: 4,
					slidesPerGroup: 4,
				},
			},
			on: {
				init () {
					// 重新設定顏色位置 (原本的Function 在 all)
					window.pdListColorRebuild && pdListColorRebuild();
				}
			}
		});
	}

	window.addEventListener('load', function () {
		if (document.querySelector(pdRecommendCarousel) !== null) {
			pageScrollAdd(pdRecommendCarousel, pdRecommendBuild);
		}
	});
	/* ---------------------------------------- [END] Product Recommend | 推薦產品 */

	/* ---------------------------------------- [START] Share to SNS */
	var anchors = document.querySelectorAll('.sharer');
	[].forEach.call(anchors, function (anchor) {
		anchor.addEventListener(
			'click',
			function (e) {
				e.preventDefault();

				var target = e.currentTarget;

				// Get title
				var articleTitle = document.querySelector('#article-title')
					? document.querySelector('#article-title').innerText
					: document.title;

				// change title to encode
				articleTitle = encodeURI(articleTitle);

				var hashTags = target.getAttribute('data-hashtags') || ''

				// grab the base sharing URL
				var url = target.href;

				// Change "{articleUrl}" to page url
				var shareUrl = url
					.replace(/CarticleUrlC/gm, window.location.href)
					.replace(/CarticleTitleC/gm, articleTitle)
					.replace(/ChashtagsC/gm, hashTags);

				// grab the name we want to give the window (parameter 2 on window.open)
				// MDN: 新視窗的名稱。該字元串可以用來作為超連結 <a> 或表單 <form> 元素的目標屬性值。字元串中不能含有空白字元。注意：strWindowName 並不是新視窗的標題。
				var windowName = target.getAttribute('data-windowName') || 'Share';
				windowName.replace(/\s/g, ''); // 移除空白

				// Grab parameter 3 for window.oprn (window settings)
				var windowSettings =
					target.getAttribute('data-settings') ||
					'menubar=no,toolbar=no,resizable=no,scrollbars=yes,height=700,width=550';

				// call window.open
				var otherWindow = window.open(shareUrl, windowName, windowSettings);
				otherWindow.opener = null;
				// otherWindow.location = shareUrl;
			},
			false
		);
	});
	/* ---------------------------------------- [END] Share to SNS */

	/* ---------------------------------------- [START] Navigator Share */
	/* 條件：一定要是HTTPS環境下才可以使用
	 * Ref: https://w3c.github.io/web-share/
	 */
	var shareButton = document.querySelectorAll('.js-navigator-share');
	// var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	[].forEach.call(shareButton, function (el) {
			// 要隱藏的項目（相同功能物件）
		const hideEl = (el.dataset && el.dataset['hideEl']) ? document.querySelector(el.dataset['hideEl']) : null; // 要隱藏的項目
		
		if (!isMobile || !navigator.share) {
			// 將非 Mobile 裝置、不支援 navigator share 擋下
			el.classList.add('hide'); // Hide Class
			el.tabIndex = -1;

			// 要隱藏的項目（相同功能物件）
			hideEl && hideEl.classList.remove('hide');
		} else {
			el.classList.remove('hide');
			
			// 要隱藏的項目（相同功能物件）
			hideEl && hideEl.classList.add('hide');
		}

		el.addEventListener('click', function (event) {
			if (navigator.share) {
				navigator
					.share({
						title: document.title,
						url: location.href,
					})
					.catch(console.error);
			}
		});
	});
	/* ---------------------------------------- [END] Navigator Share */

	/* ---------------------------------------- [START] Copy link */
	/* clipboard.js — Copy to clipboard without Flash
	 * https://clipboardjs.com/
	 */

	// 訊息由Toastr取代
	// var successMsg;
	// var clipTimer = null;

	/* 複製成功訊息 */
	// function addCopySuccess(text) {
	// 	if (successMsg === undefined) {
	// 		successMsg = document.createElement('div');
	// 		successMsg.className = 'copysuctip';
	// 		// successMsg.innerText = '複製成功';
	// 		successMsg.setAttribute('aria-live', 'assertive');
	// 	}
	// 	successMsg.innerText = text || '複製成功';
	// 	document.body.appendChild(successMsg);

	// 	// Remove
	// 	clearTimeout(clipTimer);
	// 	clipTimer = null;
	// 	clipTimer = setTimeout(function () {
	// 		successMsg.remove();
	// 		clipTimer = null;
	// 	}, 3000);
	// }

	function buildClipboardJS() {
		if (window.ClipboardJS !== undefined) {
			var clipboard = new ClipboardJS('.js-copy-link', {
				text: function (trigger) {
					var text = window.location.href;
					return text;
				},
			});

			clipboard.on('success', function (e) {
				e.clearSelection();
				toast('success', e.trigger.getAttribute('data-success'));
				e.trigger.blur();
			});
		}
	}
	window.addEventListener('load', buildClipboardJS);
	/* ---------------------------------------- [END] Copy link */

	/* ---------------------------------------- [START] 整頁 Scroll 監測 (After) */
	var pageScrollThrottle = null;

	var pageScrollHandler = function () {
		if (pageScrollCheckList.length === 0) {
			return false;
		} // 因為改成 Page Global 執行，所以不會停止

		for (var i = 0; i < pageScrollCheckList.length; i++) {
			if (isInViewport(pageScrollCheckList[i].el)) {
				pageScrollCheckList[i].fun();
				pageScrollCheckList[i].build = true;
			}
		}
		pageScrollClean();
		// if (pageScrollCheckList.length === 0) {
		// 	off(window, 'scroll', pageScrollThrottle);
		// }
	};

	window.addEventListener('load', function () {
		pageScrollThrottle = throttle(pageScrollHandler, 50, 500); // 節流作用
		window.addEventListener('scroll', pageScrollThrottle);
		pageScrollHandler();
	});
	/* ---------------------------------------- [END] 整頁 Scroll 監測 (After) */
})(window, document);
